/**
 * CollabV3ProgressBar 컴포넌트
 * @description 모금 · 조건부 참가비의 진행 막대. 목표를 넘겨도(모금 400%) 막대는 넘치지 않는다.
 *   목표 미달로 끝난 카드는 흐린 색이다(앱 `progressTone='failed'`).
 * @example <CollabV3ProgressBar percent={64} label="Fundraising progress" />
 */
import { memo } from "react";

import { collabV3CardStyles } from "./CollabV3Card.styles";
import type { CollabV3ProgressBarProps } from "./CollabV3Card.types";

const MAX_PERCENT = 100;

const CollabV3ProgressBar = memo<CollabV3ProgressBarProps>(
  ({ percent, label, tone = "brand" }) => {
    const styles = collabV3CardStyles.progress;
    const width = Math.min(Math.max(Math.round(percent), 0), MAX_PERCENT);
    return (
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={width}
        aria-valuemin={0}
        aria-valuemax={MAX_PERCENT}
        className={styles.track}
      >
        <span
          className={`${styles.fill} ${styles[tone]}`}
          style={{ width: `${width}%` }}
        />
      </div>
    );
  },
);

CollabV3ProgressBar.displayName = "CollabV3ProgressBar";

export default CollabV3ProgressBar;
